$.fn.compareRow = function(row_selector, sticky_selector, offset) {
  let self = this

  self.find(sticky_selector).addClass('js-compare__sticky-content--hidden');

  let $stickyElement = self.find(sticky_selector).first().clone();
  $stickyElement.addClass('js-compare__sticky');
  establish_sticky_position($stickyElement);
  self.prepend($stickyElement);

  establish_height();

  manage_selected();

  if($.mlmi.mobile.isMobile){
    reset();
  }

  function reset(){
    self.find(sticky_selector).css('height', '');
    $('.js-compare__sticky-content--hidden').removeClass('js-compare__sticky-content--hidden');
  }

  function establish_height(){
      self.find(sticky_selector).css('height', '');
      //Assign biggest height to all tables
      var biggest_height = 0;
      self.find(sticky_selector).each(function( index ) {
        if($(this).height() > biggest_height){
          biggest_height = $(this).height();
        }
      });
      self.find(sticky_selector).height(biggest_height);
  }

  function establish_sticky_position(sticky_element){
    sticky_element.css('width', self.find(sticky_selector).last().width())
    sticky_element.css('right', ($("body").prop("clientWidth") - self.width()) / 2)
  }

  function manage_selected(){
    // before section
    if(window.scrollY < self.offset().top - $('header.header').height() - 30){
      self.find(row_selector).removeClass('js-compare__selected-section');
      self.removeClass('js-compare--selected');
      return false;
    }else{
      self.addClass('js-compare--selected');
    }

    $(self.find(row_selector).get().reverse()).each(function( index ) {
      let the_section = $(this);
      offset_show_next_section = 100;

      if(window.scrollY > the_section.offset().top - $('header.header').height() - 30 - offset_show_next_section){
        //manage selected section
        if(!the_section.hasClass('js-compare__selected-section')){

          //Only change content if required
          if(self.find('.js-compare__selected-section').length > 0 || the_section.index() > 1){
            self.addClass('js-compare--changing-content');

            setTimeout(function(){
              $stickyElement.html(the_section.find(sticky_selector).html());
              self.removeClass('js-compare--changing-content');
            }, 200);
          }

          self.find(row_selector).removeClass('js-compare__selected-section');
          the_section.addClass('js-compare__selected-section');
        }

        //manage last row
        offset = window.scrollY - the_section.offset().top + $('header.header').height() + 30;
        if(the_section.is(':last-child') && offset > 0){
          self.addClass('js-compare--passed');
        }else{
          //the_section.find('.compare-row__table').css('top', offset);
          self.removeClass('js-compare--passed');
        }

        return false;
      }
    });
  }

  $( window ).resize(function() {
    if(!$.mlmi.mobile.isMobile){
      self.find(sticky_selector).addClass('js-compare__sticky-content--hidden');
      establish_height();
      establish_sticky_position($('.js-compare__sticky'));
    }else{
      reset();
    }
  });

  $(window).scroll(function() {
    if(!$.mlmi.mobile.isMobile){
      manage_selected()
    }
  });



  return function() {
    return self
  }()
};
